import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// import { AuthContext } from "../../contexts/AuthContext";
import { AuthContext } from "../../context/AuthContext";

const PrivateRoute = () => {
  const { isLoggedIn } = useContext(AuthContext);
  // const isLoggedIn = true;
  
  const location = useLocation();

  return isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ lastLocation: location }} replace />
  );
};

export default PrivateRoute;